import { render, staticRenderFns } from "./OwnersChart.vue?vue&type=template&id=60d037d9"
import script from "./OwnersChart.vue?vue&type=script&lang=js"
export * from "./OwnersChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports